module.exports = "/static/media/tablet-portrait.dc405b38.svg";